module.exports = __webpack_public_path__ + "static/media/AajuBaajuJourney.547ddd25.jpg";